import { cn } from '@/lib/utils'

interface BadgeProps {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'error' | 'info' | 'demo' | 'outline'
  size?: 'sm' | 'md'
  children: React.ReactNode
  className?: string
  'aria-label'?: string
}

export function Badge({ variant = 'default', size = 'sm', children, className, 'aria-label': ariaLabel }: BadgeProps) {
  const base = 'inline-flex items-center font-medium rounded-full border'
  const variants = {
    default: 'bg-soft-panel border-border-gray text-deep-ink',
    success: 'bg-green-50 border-validation-green/30 text-validation-green',
    warning: 'bg-amber-50 border-uncertainty-amber/30 text-uncertainty-amber',
    danger: 'bg-rose-50 border-risk-rose/30 text-risk-rose',
    error: 'bg-red-50 border-red-300/50 text-red-600',
    info: 'bg-blue-50 border-blue-300/50 text-blue-600',
    demo: 'bg-signal-cyan/10 border-signal-cyan/30 text-signal-cyan',
    outline: 'border-border-gray text-deep-ink bg-transparent',
  }
  const sizes = { sm: 'text-xs px-2 py-0.5', md: 'text-sm px-2.5 py-1' }
  return <span aria-label={ariaLabel} className={cn(base, variants[variant], sizes[size], className)}>{children}</span>
}
